const PROVIDERS = [
  {
    identifier: 'spamhaus-zen',
    name: 'Spamhaus ZEN',
    dns_zone: 'zen.spamhaus.org',
    lookup_url: 'https://check.spamhaus.org/listed/?searchterm={ip}',
    weight: 3,
    enabled: true,
    return_codes: { '127.0.0.2': 'SBL', '127.0.0.4': 'XBL-CBL', '127.0.0.10': 'PBL' },
  },
  {
    identifier: 'barracuda',
    name: 'Barracuda RBL',
    dns_zone: 'b.barracudacentral.org',
    lookup_url: 'https://www.barracudacentral.org/lookups/lookup-reputation',
    weight: 2,
    enabled: true,
    return_codes: { '127.0.0.2': 'Listed' },
  },
  {
    identifier: 'spamcop',
    name: 'SpamCop',
    dns_zone: 'bl.spamcop.net',
    lookup_url: 'https://www.spamcop.net/bl.shtml?{ip}',
    weight: 1,
    enabled: false,
    return_codes: {},
  },
  {
    identifier: 'sorbs',
    name: 'SORBS DUL',
    dns_zone: 'dul.dnsbl.sorbs.net',
    lookup_url: 'https://www.sorbs.net/lookup.shtml',
    weight: 1,
    enabled: true,
    return_codes: {},
  },
];

const IPS = [
  { ip: '198.51.100.10', label: 'mail.valitype.de', source: 'enhance', last_scanned_at: '2026-06-16T13:00:00.000Z' },
  { ip: '198.51.100.42', label: 'mail2.valitype.de', source: 'netbox', last_scanned_at: '2026-06-16T13:00:00.000Z' },
  { ip: '198.51.100.50', label: 'mx-out.valitype.de', source: 'manual', last_scanned_at: '2026-06-16T13:00:00.000Z' },
];

export function rblProvidersFixture() {
  return { providers: PROVIDERS };
}

export function rblIpsFixture() {
  return { ips: IPS };
}

export function rblStatusFixture() {
  return {
    rows: [
      {
        ip_address: '198.51.100.10',
        label: 'mail.valitype.de',
        clean: true,
        listings: [],
      },
      {
        ip_address: '198.51.100.42',
        label: 'mail2.valitype.de',
        clean: false,
        listings: [
          {
            provider: 'spamhaus-zen',
            provider_name: 'Spamhaus ZEN',
            dns_zone: 'zen.spamhaus.org',
            return_code: '127.0.0.4',
            return_label: 'XBL-CBL',
            first_seen_at: '2026-06-13T08:14:00.000Z',
            last_checked_at: '2026-06-16T13:00:00.000Z',
            lookup_url: 'https://check.spamhaus.org/listed/?searchterm=198.51.100.42',
          },
          {
            provider: 'barracuda',
            provider_name: 'Barracuda RBL',
            dns_zone: 'b.barracudacentral.org',
            return_code: '127.0.0.2',
            return_label: 'Listed',
            first_seen_at: '2026-06-16T11:00:00.000Z',
            last_checked_at: '2026-06-16T13:00:00.000Z',
            lookup_url: 'https://www.barracudacentral.org/lookups/lookup-reputation',
          },
        ],
      },
      {
        ip_address: '198.51.100.50',
        label: 'mx-out.valitype.de',
        clean: true,
        listings: [],
      },
    ],
  };
}
